import { AutogenModelRecurringSched, AutogenRowRecurringSched } from "./autogen/AutogenModelRecurringSched";

export class ModelRecurringSched extends AutogenModelRecurringSched<RowRecurringSched> {
    constructor() {
        super(RowRecurringSched);
    }
}

export class RowRecurringSched extends AutogenRowRecurringSched {
}